import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const SUPPRESSED_EXACT = ["/auth", "/reset-password"];
const SUPPRESSED_PREFIXES = ["/vault-partner/", "/brand/", "/admin/"];

export function isNavSuppressedRoute(pathname: string): boolean {
  if (SUPPRESSED_EXACT.includes(pathname)) return true;
  return SUPPRESSED_PREFIXES.some((p) => pathname.startsWith(p));
}

/** True when the mobile bottom nav is actually rendered. */
export function useMobileNavVisible(): boolean {
  const location = useLocation();
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => setAuthed(!!data.user));
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => setAuthed(!!session?.user),
    );
    return () => subscription.unsubscribe();
  }, []);

  if (!authed) return false;
  if (isNavSuppressedRoute(location.pathname)) return false;
  return true;
}
